@let it = item();
@let posterUrl = poster();

@if (isRadio()) {
    <div class="radio-channel cursor-pointer relative" [class.active]="active()">
        <div class="radio-channel-circle"></div>
        <div class="radio-channel-container flex flex-col items-center">
            @if (active()) {
                <div class="active-icon-container">
                    <img class="icon" [src]="skinning.getImage('icon_tile_auditorium')" alt="">
                </div>
            }
            <div class="icon-container flex items-center justify-center">
                @if (it.channelIcon) {
                    <img class="icon" [transcodeImage]="it.channelIcon" alt="">
                }
            </div>
            <div class="timeline">
                <div class="elapsed" [style.width.%]="progressPercent()"></div>
            </div>
            <div class="title-container text-center flex items-center justify-center">
                <span class="title w-full h-auto">{{ restricted() ? ('common.protected_content_title' | transloco) : it.title }}</span>
            </div>
            <div class="buttons flex">
                @if (!active()) {
                    <div (click)="onClick()">
                        <img [src]="skinning.getImage('icon_more_round')" alt="more">
                    </div>
                    <div (click)="onPlay($event)">
                        <img [src]="skinning.getImage('icon_play')" alt="play">
                    </div>
                } @else {
                    <div (click)="onStop($event)">
                        <img [src]="skinning.getImage('icon_stop')" alt="stop">
                    </div>
                }
            </div>
        </div>
    </div>
} @else if (isCircle()) {
    <div class="circle-card cursor-pointer flex flex-col items-center"
         MiniDetails [item]="it" [isCarousel]="true" [removeItemConfig]="removeItemConfig()"
         (click)="onClick()">
        <div class="poster-circle relative">
            <div class="poster-clip absolute inset-0 rounded-full overflow-hidden bg-[var(--background_primary_7,#222)]">
                @if (posterUrl) {
                    <div class="poster absolute inset-0 bg-cover bg-center bg-no-repeat"
                         [transcodeImage]="posterUrl"></div>
                } @else if (placeholderIcon()) {
                    <div class="poster-placeholder absolute inset-0 flex items-center justify-center">
                        <img class="placeholder-icon" [src]="placeholderIcon()" alt="">
                    </div>
                }
                @if (restricted()) {
                    <content-rating-lock />
                }
            </div>
            @if (showBadge()) {
                <badge data-testid="asset-card_badge"
                    [badge]="it.badge"
                    [circle]="true"
                    [variant]="BadgeVariant.ItemList"
                    [availabilityStartTime]="it.availabilityStartTime"
                    [availabilityEndTime]="it.availabilityEndTime"
                    [hasUpcomingEnabled]="it.hasUpcomingEnabled ?? false"
                    [hasOutgoingEnabled]="it.hasOutgoingEnabled ?? false">
                </badge>
            }
        </div>
        @if (showTitle() && it.title) {
            <div class="title font-medium mt-3 text-center line-clamp-2 text-white text-shadow">
                {{ restricted() ? ('common.protected_content_title' | transloco) : it.title }}
            </div>
        }
    </div>
} @else {
    <div class="item br-tile cursor-pointer relative w-full h-full overflow-hidden"
         MiniDetails [item]="it" [isCarousel]="true" [removeItemConfig]="removeItemConfig()"
         (click)="onClick()">
        @if (posterUrl) {
            <div class="poster absolute inset-0 bg-cover bg-center bg-no-repeat"
                 [transcodeImage]="posterUrl" data-testid="rail_card-poster">
            </div>
        } @else {
            <div class="poster-placeholder absolute inset-0 bg-cover bg-center bg-no-repeat"
                 [style.background-image]="placeholderIcon() ? 'url(' + placeholderIcon() + ')' : null">
            </div>
        }

        @if (restricted()) {
            <content-rating-lock />
        }

        <div class="shadow bottom-shadow absolute inset-0 pointer-events-none"></div>

        <div class="top-header absolute top-0 left-0 right-0 flex justify-between items-start p-3 z-[2]">
            @if (topChart()) {
                <div class="top-chart-wrapper flex items-center overflow-hidden">
                    <div class="top-chart font-bold leading-none select-none" data-testid="card_top-chart">{{ index() + 1 }}</div>
                </div>
            }
            @if (it.channelIcon) {
                <img class="channel-icon h-6 w-auto" [transcodeImage]="it.channelIcon" transcodeAxis="height" alt="">
            }
            @if (showBadge() && badgePosition() === 'top_right') {
                <badge data-testid="asset-card_badge"
                    [badge]="it.badge"
                    [circle]="false"
                    [variant]="BadgeVariant.ItemList"
                    [availabilityStartTime]="it.availabilityStartTime"
                    [availabilityEndTime]="it.availabilityEndTime"
                    [hasUpcomingEnabled]="it.hasUpcomingEnabled ?? false"
                    [hasOutgoingEnabled]="it.hasOutgoingEnabled ?? false">
                </badge>
            }
        </div>

        @if (progressPercent() > 0) {
            <div class="timeline absolute bottom-0 left-0 h-[5px] z-[1]"
                 [style.width.%]="progressPercent()"></div>
        }

        <div class="info absolute bottom-0 left-0 right-0 px-2 pb-2 z-[2]">
            @if (showBadge() && badgePosition() === 'bottom_center') {
                <badge data-testid="asset-card_badge"
                    [badge]="it.badge"
                    [circle]="false"
                    [variant]="BadgeVariant.ItemList"
                    [availabilityStartTime]="it.availabilityStartTime"
                    [availabilityEndTime]="it.availabilityEndTime"
                    [hasUpcomingEnabled]="it.hasUpcomingEnabled ?? false"
                    [hasOutgoingEnabled]="it.hasOutgoingEnabled ?? false">
                </badge>
            }
            @if (showTitle() && it.title) {
                <div class="title font-semibold line-clamp-2 text-white text-shadow" data-testid="asset-card_title">{{ restricted() ? ('common.protected_content_title' | transloco) : it.title }}</div>
            }
            @if (showSubtitle() && !restricted()) {
                <div class="subtitle line-clamp-1 text-white/80 text-sm text-shadow">{{ it.subtitle }}</div>
            }
            @if (showTime() && !isUpcomingCatalogue() && airTime()) {
                <div class="time font-bold text-shadow text-white" data-testid="asset-card_time">{{ airTime() }}</div>
            }
        </div>
    </div>
}
